
export default function getResource(label, vars = []) {
    const resources = {
        oosAlternateLinkLegend: 'Select alternate'
    };

    return resources[label];
}
